(function () {
  function init() {
    var cards = document.querySelectorAll('.category-card');
    cards.forEach(function (c) {
      var kc = c.querySelector('.kc');
      if (!kc || c.__kc) return;
      c.__kc = true;
      c.addEventListener('mousemove', function (e) {
        var r = c.getBoundingClientRect(), x = (e.clientX - r.left) / r.width - 0.5, y = (e.clientY - r.top) / r.height - 0.5;
        kc.style.transform = 'perspective(700px) rotateY(' + (x * 14).toFixed(2) + 'deg) rotateX(' + (-y * 12).toFixed(2) + 'deg) scale(1.04)';
      });
      c.addEventListener('mouseleave', function () { kc.style.transform = ''; });
    });
    if (window.matchMedia && matchMedia('(hover: none)').matches && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { e.target.classList.toggle('is-live', e.isIntersecting && e.intersectionRatio > 0.6); });
      }, { threshold: [0, 0.6] });
      cards.forEach(function (c) { if (c.querySelector('.kc')) io.observe(c); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();